import * as React from "react";
import 'antd/dist/antd.css';
import {Form, Input, Button, DatePicker, Select, Checkbox, notification, Icon, Upload, message} from "antd";
import FormApi from "./api";
import moment from "moment";

const {Option} = Select;

const openNotificationWithIcon = (type, status) => {
    let message = ''
    let description = ''
    switch (status) {
        case 409:
            message = 'Email already in use'
            description = 'The email you entered is already being used by another user. Please enter a different one'
            break
        case 500:
            message = 'Server Error'
            description = 'There was a server error, please contact your ESN section'
            break
        default:
            message = 'Error'
            description = 'There was an error, please contact your ESN section'
    }

    notification[type]({
        message: message,
        description: description,
    });
};

class Registration extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loaded: false,
            cities: null,
            city: null,
            universities: null,
            university: null,
            faculties: null,
            faculty: null,
            section: null,
            semesters: null,
            name: null,
            surname: null,
            email: null,
            password: null,
            countries: null,
            country: null,
            document: null,
            birthday: null,
            gender: null,
            phone: null,
            photo: null,
            facebook: null,
            subscribed: false,
            imageLoading: false,
            imageUrl: null,
            profile: null,
            verificationLoading: false,
            verificationUrl: null,
            verificationFileList: [],
            success: false
        };
    }


    componentDidMount() {
        // Global, date-based active semesters for the registration dropdown.
        FormApi.getSemesters().then((res) => {
            this.setState({
                semesters: res.data.map((semester) => {
                    return {
                        key: String(semester.id),
                        name: semester.name + ' ' + semester.academicYear,
                        academicYear: semester.academicYear
                    }
                })
            })
        });

        FormApi.getCities().then((res) => {
            this.setState({
                cities: res.data.map((city) => {
                    return {
                        key: city.id,
                        name: city.name
                    }
                }),
                universities: null,
                university: null,
                faculties: null,
                faculty: null,
                loaded: true
            }, () => {
                FormApi.getCountries().then(res => {
                    this.setState({
                        countries: res.data.map((country) => {
                            return {
                                key: country.id,
                                name: country.name
                            }
                        })
                    })
                })
            });
        });
    };

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                FormApi.saveStudent(this.state).then((res) => {
                    this.setState({
                        success: true
                    })
                }).catch(e => {
                    openNotificationWithIcon('error', e.response.status)
                });
                console.log('Form successfully submitted')
            }
        })
    };

    handleCityChange = (id) => {
        FormApi.getUniversities(id).then((res) => {
            this.setState({
                city: null,
            }, () => {
                this.setState({
                    city: id,
                    faculties: null,
                    faculty: null,
                    university: null,
                    universities: res.data.map((university) => {
                        return {
                            key: university.id,
                            name: university.name
                        }
                    })
                })
            });
        });
    };

    handleUniversityChange = (id) => {
        FormApi.getFaculties(id).then((res) => {
            this.setState({
                faculty: null,
                faculties: null,
                university: null,
            }, () => {               //Using a callback so that the faculty list can be re-rendered
                this.setState({        //on University change
                    university: id,
                    faculties: res.data.map((faculty) => {
                        return {
                            key: faculty.id,
                            name: faculty.name
                        }
                    })
                }, () => {
                    FormApi.getSection(id).then((res) => {
                        this.setState({
                            section: res.data
                        })
                    })
                });
            });
        });
    };

    handleFacultyChange = (id) => {
        this.setState({
            faculty: id
        })
    };

    handleFormItemChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        });
    };

    handleCountryChange = (id) => {
        this.setState({
            country: id
        })
    };

    handleGenderChange = (id) => {
        this.setState({
            gender: id
        })
    };

    handleBirthdayChange = (date) => {
        if (date !== null) {
            this.setState({
                birthday: date.format('DD/MM/YYYY')
            });
        }
    };

    handleSemesterChange = (id) => {
        this.setState({
            semester: id
        })
    };

    handleSubscription = (e) => {
        this.setState({
            subscribed: e.target.checked
        })
    };

    getBase64 = (img, callback) => {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    }

    beforePhotoUpload = (file) => {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
            message.error('You can only upload JPG/PNG files!');
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            message.error('Image must be smaller than 2MB!');
        }
        return isJpgOrPng && isLt2M;
    }

    handlePhotoChange = info => {
        if (info.file.status === 'uploading') {
            this.setState({imageLoading: true});
            return;
        }
        if (info.file.status === 'done') {
            this.setState({
                imageUrl: info.file.response.url,
            }, () => {
                this.getBase64(info.file.originFileObj, (imageUrl) => {
                    this.setState({
                        profile: imageUrl,
                        imageLoading: false
                    })
                })
            })
        }
    };

    beforeVerificationUpload = (file) => {
        const isJpgOrPngOrPdf = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'application/pdf';
        if (!isJpgOrPngOrPdf) {
            message.error('You can only upload JPG/PNG/PDF files!');
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            message.error('Image must be smaller than 2MB!');
        }
        return isJpgOrPngOrPdf && isLt2M;
    }

    handleVerificationChange = info => {
        let fileList = [...info.fileList]
        fileList = fileList.slice(-1).map(file => {
            if (file.response) {
                // Component will show file.url as link
                file.url = file.response.url;
            }

            return file
        })

        this.setState({
            verificationFileList: fileList,
        }, () => {
            if (info.file.status === 'uploading') {
                this.setState({verificationLoading: true});
                return;
            }
            if (info.file.status === 'done') {
                this.setState({
                    verificationUrl: info.file.response.url
                }, () => {
                    this.setState({verificationLoading: false})
                })
            }
        })
    };

    render() {
        const {getFieldDecorator} = this.props.form;
        const uploadButton = (
            <div>
                <Icon type={this.state.loading ? 'loading' : 'plus'}/>
                <div className="ant-upload-text">Upload</div>
            </div>
        );

        return (
            <div>
                {!this.state.success &&
                <Form onSubmit={this.handleSubmit} className="registration-form">
                    <Form.Item label='City:'>
                        <Select
                            placeholder="Select a city"
                            onChange={this.handleCityChange}>
                            {this.state.loaded && this.state.cities.map(city => (
                                <Option key={city.key}>{city.name}</Option>
                            ))}
                        </Select>
                    </Form.Item>
                    {this.state.city &&
                    <Form.Item label='University:'>
                        <Select
                            placeholder="Select a University"
                            onChange={this.handleUniversityChange}>
                            {this.state.universities.map(university => (
                                <Option key={university.key}>{university.name}</Option>
                            ))}
                        </Select>
                    </Form.Item>
                    }
                    {this.state.university &&
                    <Form.Item label='Faculty:'>
                        <Select
                            placeholder="Select a Faculty"
                            onChange={this.handleFacultyChange}>
                            {this.state.faculties.map(faculty => (
                                <Option key={faculty.key}>{faculty.name}</Option>
                            ))}
                        </Select>
                    </Form.Item>
                    }
                    {this.state.faculty &&
                    <div>
                        <p>Your ESN section is: <b>{this.state.section.name}</b></p>
                        <p><img src={FormApi.getBaseUrl() + this.state.section.logo} height='80px' alt="section-logo"/>
                        </p>
                        <Form.Item label='Duration of stay:'>
                            {getFieldDecorator('semester', {
                                rules: [
                                    {
                                        required: true,
                                        message: 'Please select a semester!'
                                    }
                                ],
                            })(
                                <Select
                                    id='semester'
                                    onChange={this.handleSemesterChange}
                                    placeholder="Select your duration of stay"
                                >
                                    {(this.state.semesters || []).map((semester) => (
                                        <Option key={semester.key}>{semester.name}</Option>
                                    ))}
                                    {(this.state.semesters || []).length > 1 &&
                                    <Option key='full'>
                                        Full year {this.state.semesters[0].academicYear}
                                    </Option>
                                    }
                                </Select>
                            )}
                        </Form.Item>
                        <Form.Item label='Name:'>
                            {getFieldDecorator('name', {
                                rules: [
                                    {
                                        required: true,
                                        message: 'Please enter your name!'
                                    }
                                ],
                            })(
                                <Input
                                    id='name'
                                    placeholder="Enter your name"
                                    onChange={this.handleFormItemChange}
                                    value={this.state.name}
                                >
                                </Input>
                            )}
                        </Form.Item>
                        <Form.Item label='Surname:'>
                            {getFieldDecorator('surname', {
                                rules: [
                                    {
                                        required: true,
                                        message: 'Please enter your surname!'
                                    }
                                ],
                            })(
                                <Input
                                    id='surname'
                                    placeholder="Enter your surname"
                                    onChange={this.handleFormItemChange}
                                    value={this.state.surname}
                                >
                                </Input>
                            )}
                        </Form.Item>
                        <Form.Item label='Email:'>
                            {getFieldDecorator('email', {
                                rules: [
                                    {
                                        required: true,
                                        message: 'Please enter your email address!'
                                    },
                                    {
                                        pattern: '^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9_\\-\\.]+)\\.([a-zA-Z]{2,5})$',
                                        message: 'Please enter a valid email address!'
                                    }
                                ],
                            })(
                                <Input
                                    id='email'
                                    placeholder="Enter your email"
                                    onChange={this.handleFormItemChange}
                                    value={this.state.email}
                                >
                                </Input>
                            )}
                        </Form.Item>
                        <Form.Item label='Country:'>
                            {getFieldDecorator('country', {
                                rules: [
                                    {
                                        required: true,
                                        message: 'Please select a country!'
                                    }
                                ],
                            })(
                                <Select
                                    showSearch
                                    id='country'
                                    onChange={this.handleCountryChange}
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    placeholder="Select a country"
                                >
                                    {this.state.countries.map(country => (
                                        <Option key={country.key}>{country.name}</Option>
                                    ))}
                                </Select>
                            )}
                        </Form.Item>
                        <Form.Item label='ID/Passport no:'>
                            {getFieldDecorator('document', {
                                rules: [
                                    {
                                        required: true,
                                        message: 'Please enter your ID/Passport!'
                                    }
                                ],
                            })(
                                <Input
                                    id='document'
                                    placeholder="Enter your ID/Passport no"
                                    onChange={this.handleFormItemChange}
                                    value={this.state.document}
                                >
                                </Input>
                            )}
                        </Form.Item>
                        <Form.Item label='Gender:'>
                            {getFieldDecorator('gender', {
                                rules: [
                                    {
                                        required: true,
                                        message: 'Please select a gender!'
                                    }
                                ],
                            })(
                                <Select
                                    id='gender'
                                    onChange={this.handleGenderChange}
                                    placeholder="Select your gender"
                                >
                                    <Option key='M'>Male</Option>
                                    <Option key='F'>Female</Option>
                                    <Option key='O'>Other</Option>
                                </Select>
                            )}
                        </Form.Item>
                        <Form.Item label='Birthday:'>
                            {getFieldDecorator('birthday', {
                                rules: [
                                    {
                                        required: true,
                                        message: 'Please select your birthday!'
                                    }
                                ],
                            })(
                                <DatePicker onChange={this.handleBirthdayChange}
                                            defaultValue={moment(this.state.birthday, 'DD/MM/YYYY')}
                                            format='DD/MM/YYYY'/>
                            )}
                            <div>
                                <p><Icon type="info-circle" theme="twoTone"/> To change the year, click
                                    on <b>{moment().year()}</b> on the calendar</p>
                            </div>
                        </Form.Item>

                        <Form.Item label='Phone:'>
                            {getFieldDecorator('phone', {
                                rules: [
                                    {
                                        required: true,
                                        message: 'Please enter your phone number!'
                                    }
                                ],
                            })(
                                <Input
                                    id='phone'
                                    placeholder="Enter your Phone number"
                                    onChange={this.handleFormItemChange}
                                    value={this.state.phone}
                                >
                                </Input>
                            )}
                        </Form.Item>
                        <Form.Item label='Facebook:'>
                            <Input
                                id='facebook'
                                placeholder="Please enter your Facebook URL"
                                onChange={this.handleFormItemChange}
                                value={this.state.facebook}
                            >
                            </Input>
                        </Form.Item>
                        <Form.Item label='Photo: (jpg|png, <2MB)'>
                            {
                                getFieldDecorator('photo', {
                                    rules: [
                                        {
                                            required: true,
                                            message: 'Please upload a photo!'
                                        }
                                    ],
                                })(
                                    <Upload
                                        name="photo"
                                        listType="picture-card"
                                        className="photo_uploader"
                                        showUploadList={false}
                                        action={FormApi.getBaseUrl() + 'api/image'}
                                        beforeUpload={this.beforePhotoUpload}
                                        onChange={this.handlePhotoChange}
                                    >
                                        {this.state.profile ?
                                            <img src={this.state.profile} alt="profile"
                                                 style={{width: '100%'}}/> : uploadButton}
                                    </Upload>
                                )
                            }
                        </Form.Item>
                        <Form.Item label='Student status confirmation: (jpg|png|pdf <2MB)'>
                            {
                                getFieldDecorator('verification', {
                                    rules: [
                                        {
                                            required: true,
                                            message: 'Please upload a confirmation document!'
                                        }
                                    ],
                                })(
                                    <Upload
                                        name="verification"
                                        showUploadList={true}
                                        action={FormApi.getBaseUrl() + 'api/verification'}
                                        multiple={false}
                                        beforeUpload={this.beforeVerificationUpload}
                                        fileList={this.state.verificationFileList}
                                        onChange={this.handleVerificationChange}
                                    >
                                        <Button>
                                            <Icon type="upload"/> Upload
                                        </Button>
                                    </Upload>
                                )
                            }
                            <div>
                                <p><Icon type="info-circle" theme="twoTone"/> Upload a document that indicates your exchange student status (eg. letter of acceptance)</p>
                            </div>
                        </Form.Item>
                        <Form.Item label='Newsletter:'>
                            <Checkbox onChange={this.handleSubscription}><b>I want to receive news, events and
                                promotions
                                from ESN</b></Checkbox>
                        </Form.Item>
                        <p>By clicking "Submit" and having been informed of the <a
                            href="https://esngreece.gr/privacy-policy" target='_parent' rel="noopener noreferrer">Privacy
                            Policy</a> of {this.state.section.name}, who are the Data
                            controllers, I understand that the processing of the Data I provided with is necessary for
                            the purpose of communication (receiving ESNcard updates & offers via email). I understand
                            that the consent to the processing of my Data may be revoked by sending an email at <a
                                href="mailto:dpo@esngreece.gr">dpo@esngreece.gr</a>.</p>
                        <Form.Item>
                            <Button type="primary"
                                    htmlType="submit"
                                    disabled={!this.state.faculty}
                            >
                                Submit
                            </Button>
                        </Form.Item>

                    </div>
                    }
                </Form>
                }
                {this.state.success &&
                <div>
                    <div style={{textAlign: "center"}}>
                        <p><img src={FormApi.getBaseUrl() + this.state.section.logo} height='120px' alt="section-logo"/>
                        </p>
                    </div>
                    <p>You have successfully registered for an ESNcard for the <b>{this.state.section.name}</b> section,
                        at a cost of €{Number(this.state.section.cardPrice).toFixed(2)}.</p>
                    {this.state.section.onlinePayments ?
                        <div>
                            <p><b>Next steps:</b></p>
                            <ul>
                                <li>You will soon receive an email with instructions on how to pay online by
                                    card
                                </li>
                            </ul>
                        </div>
                        : ''
                    }
                    {/*<li>You can receive your ESNcard from your local ESN section's office which you can find <a*/}
                    {/*    href={this.state.section.location} target='_blank' rel='noopener noreferrer'>here</a></li>*/}
                    {/*<li>You can find more info about our office hours at our <a href={this.state.section.facebook}*/}
                    {/*                                                            target='_parent'*/}
                    {/*                                                            rel='noreferrer noopener'>Facebook*/}
                    {/*    page</a></li>*/}
                    {/*<li><u>Do not forget to bring a small photo for the ESNcard</u></li>*/}

                </div>

                }
            </div>
        );
    }

}

export default Form.create()(Registration);